// extracted by mini-css-extract-plugin
export default {"ThreeDot":"ThreeDot_lO2Ns_v17-8-1","ThreeDot_NoBG":"ThreeDot_NoBG_w7mbt_v17-8-1","ThreeDot_BgOnHover":"ThreeDot_BgOnHover_WRT_Z_v17-8-1"};